/* src/app/modules/members/small-member-search/small-member-search.component.scss */
.example-option-img {
  vertical-align: middle;
  margin-right: 3px;
  border-radius: 100%;
}
/*# sourceMappingURL=small-member-search.component.css.map */
